<div class="delete-wrapper">
  <button [ngClass]="{disabled: !canDelete}" (click)="deleteThis(); $event.stopPropagation();">
    <mat-icon>delete</mat-icon>
  </button>
</div>
